import moment from 'moment-timezone'

const getMomentNow = timezone => moment().tz(timezone)

export default getMomentNow